// extracted by mini-css-extract-plugin
module.exports = {"form":"MyAccount_form__pkSY6","block":"MyAccount_block__2xiXq"};